<a [shNavigationLink]="item.navigationLink" class="sh-link sh-icon-link">
    <svg
        sh-icon
        *ngIf="item.icon && item.iconPosition === navigationItemIconPosition.Start"
        [name]="item.icon"
        [size]="iconSize"
        aria-hidden="true"
        [ngClass]="iconClassNames"
    ></svg>

    {{ item.label }}

    <sh-badge *ngIf="item.badge" [badge]="item.badge" [ngClass]="badgeClassNames"></sh-badge>

    <svg
        sh-icon
        *ngIf="item.icon && item.iconPosition !== navigationItemIconPosition.Start"
        [name]="item.icon"
        [size]="iconSize"
        aria-hidden="true"
        [ngClass]="iconClassNames"
    ></svg>
</a>
